import React from "react";
import {useTranslation} from "react-i18next";
import {Link, useLocation} from "react-router-dom";
import {Popover, Row} from "antd";
import {Attention} from "../../../models/attentions/attention";

interface NavigationItemProps {
    path: string,
    name?: string,
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
    className: string,
    elementModifier?: string
    minimized?: boolean
    attention: Attention | null;
}

export const NavigationItem: React.FC<NavigationItemProps> = (
    {
        path,
        icon,
        className = 'blue',
        name = '',
        minimized,
        attention
    }) => {

    const {pathname} = useLocation();
    const {t} = useTranslation("translation", {useSuspense: false});
    const Icon = icon;
    const active = pathname.includes(path)

    if (minimized) {
        return (
            <Popover
                placement="bottom"
                content={t(name)}
                overlayClassName={"nav-item-popover"}
            >
                <Link to={path} className={active ? className + " page_header_container-link-active" : className} style={{alignItems: "center", justifyContent: "center"}}>
                    <Row justify="center" align="middle" className={'nav-img-container'}>
                        <Icon/>
                        {attention && attention.value > 0 ? (
                            <div className={"nav-attentions nav-attentions-" + attention.level}>{attention.value}</div>
                        ) : null}
                    </Row>
                </Link>
            </Popover>
        );
    }

    return (
        <Link to={path} className={active ? className + " page_header_container-link-active" : className} style={{alignItems: "center", justifyContent: "center"}}>
            <Row justify="center" align="middle" className={'nav-img-container'}>
                <Icon/>
                {attention && attention.value > 0 ? (
                    <div className={"nav-attentions nav-attentions-" + attention.level}>{attention.value}</div>
                ) : null}
                <span>{t(name)}</span>
            </Row>
        </Link>
    );
}
